const Resources = {

    table_headers: [
        { 
          text:     'Walking #',
          type:     'input',
          style:     'width: 45%',
          sort_type: 'number',
          value:    'walking_number'
        },
        { 
            text:   'Door #',
            sort_type: 'number',
            value:  'door_number'
        },
        { 
            text:   'Description',
            value:  'sort_desc'
        },
        { 
            text:   'Area',
            value:  'area_name'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Utilities',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Walking Number Update',
            href:   '/utilities-walking-number-update',
            arrow:  "",
        },
    ],

}

export default Resources;